"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageVisibilityChecker = void 0;
var util_1 = require("../../../util");
var timeoutDuration = 30000;
var PageVisibilityChecker = /** @class */ (function () {
    function PageVisibilityChecker(dependency) {
        var _this = this;
        this.dependency = dependency;
        this.timer = 0;
        this.isTimeout = false;
        this.needGetReceiverClient = false;
        this.onVisibilitychange = function () {
            if (document.visibilityState === 'hidden') {
                // hidden 的时候开始标记， 10s 后如果再 bind get 就禁止，并标识为 true
                _this.onPageHide();
            }
            else {
                _this.onPageShow();
            }
        };
        this.onPageHide = function () {
            util_1.ConnectionLog.info('pageVisibility: pagehide');
            _this.clearTimeout();
            _this.timer = setTimeout(function () {
                _this.isTimeout = true;
            }, timeoutDuration);
        };
        this.onPageShow = function () {
            var _a, _b;
            util_1.ConnectionLog.info('pageVisibility: pageshow');
            _this.clearTimeout();
            if (_this.isTimeout && _this.needGetReceiverClient) {
                (_b = (_a = _this.dependency).resumeCallback) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
            _this.isTimeout = false;
            _this.needGetReceiverClient = false;
        };
        this.addListener();
    }
    PageVisibilityChecker.prototype.dispose = function () {
        this.clearTimeout();
        document.removeEventListener('visibilitychange', this.onVisibilitychange);
        window.removeEventListener('pagehide', this.onPageHide);
        window.removeEventListener('pageshow', this.onPageShow);
    };
    Object.defineProperty(PageVisibilityChecker.prototype, "isHidden", {
        get: function () {
            return document.hidden && this.isTimeout;
        },
        enumerable: false,
        configurable: true
    });
    PageVisibilityChecker.prototype.resumeAfterVisibility = function () {
        this.needGetReceiverClient = true;
    };
    PageVisibilityChecker.prototype.addListener = function () {
        document.addEventListener('visibilitychange', this.onVisibilitychange);
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            // 针对页面跳转，对部分 safari 做兼容判断
            window.addEventListener('pagehide', this.onPageHide);
            window.addEventListener('pageshow', this.onPageShow);
        }
    };
    PageVisibilityChecker.prototype.clearTimeout = function () {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = 0;
        }
    };
    return PageVisibilityChecker;
}());
exports.PageVisibilityChecker = PageVisibilityChecker;
